<template>
  <div>
    <v-dialog v-model="bookingChannelDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="green white--text">{{formData ? this.$t('action_type.edit') : this.$t('action_type.select')}}{{ $t('booking.booking_channel') }}</v-card-title>
        <v-card-text class="py-5">
          <span>{{ $t('booking.select_booking_channel') }}</span>
          <v-autocomplete
            color
            v-model="channel"
            :items="getBookingChannelNameOnly"
            :label="$t('booking.booking_channel')"
            item-text="name"
            item-value="form"
            solo
            flat
            return-object
            background-color="grey lighten-4"
            append-outer-icon="mdi-plus"
            @click:append-outer="isChannel = true"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="bookingChannelDialog = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn color="success" elevation="0" @click="saveProducts" :disabled="!channel">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <FormBookingChannel v-model="isChannel" @onLoad="loadInit" :event="`create`"></FormBookingChannel>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FormBookingChannel from "./FormBookingChannel.vue";
export default {
  components: { FormBookingChannel },
  name: "FormAreaProduct",
  computed: {
    ...mapGetters({
      getBookingChannelNameOnly: "bookingChannel/getBookingChannelNameOnly"
    }),
    bookingChannelDialog: {
      get() {
        if (this.formData) {
          this.channel = this.formData;
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      channel: null,
      isChannel: false
    };
  },
  props: {
    value: Boolean,
    formData: Object
  },
  methods: {
    async loadInit() {
      await this.$store.dispatch(
        "bookingChannel/getBookingChannels",
        this.$route.params.projectId
          ? this.$route.params.projectId
          : this.$store.getters["markets/getProjectId"]
      );
    },
    saveProducts() {
      this.$emit("onSave", this.channel);
    }
  }
};
</script>

<style lang="scss" scoped></style>
